var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fa:send"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M27.626 4.14732C27.9207 4.36161 28.0412 4.64732 27.9876 5.00446L24.5591 25.5759C24.5145 25.8348 24.3716 26.0357 24.1306 26.1786C24.0056 26.25 23.8672 26.2857 23.7154 26.2857C23.6172 26.2857 23.51 26.2634 23.394 26.2188L17.3271 23.7411L14.0861 27.692C13.9254 27.8973 13.7067 28 13.4299 28C13.3138 28 13.2156 27.9821 13.1352 27.9464C12.9656 27.8839 12.8294 27.779 12.7268 27.6317C12.6241 27.4844 12.5728 27.3214 12.5728 27.1429V22.4688L24.144 8.28571L9.82727 20.6741L4.53719 18.5045C4.20684 18.3795 4.02827 18.1339 4.00149 17.7679C3.98363 17.4107 4.12649 17.1473 4.43005 16.9777L26.7153 4.12054C26.8493 4.04018 26.9921 4 27.1439 4C27.3225 4 27.4832 4.04911 27.626 4.14732Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaSend);
export default __webpack_public_path__ + "static/media/fa_send.64e02372a48f6f5b8059b97c06c3916c.svg";
export { ForwardRef as ReactComponent };